export const BASE_API =
  process.env.REACT_APP_BASE_API || 'https://production-dot-hcfulfillment.df.r.appspot.com/';
// export const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:3000';
